import { render, staticRenderFns } from "./r-score-widget.vue?vue&type=template&id=350038eb"
import script from "./r-score-widget.vue?vue&type=script&lang=js"
export * from "./r-score-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports